import { combineEpics } from 'redux-observable';
import { Observable } from 'rxjs';
import { INIT, LOADING, SUCCESS, ERROR } from '../../utils/constants';
import { setUserToken } from '../../utils/helpers';
import { registrationAPI, socialLoginAPI } from './api';

export const REGISTRATION = 'advaice/registration/REGISTRATION';
export const REGISTRATION_SUCCESS = 'advaice/registration/REGISTRATION_SUCCESS';
export const REGISTRATION_ERROR = 'advaice/registration/REGISTRATION_ERROR';

export const ANNUL_ERROR = 'advaice/registration/ANNUL_ERROR';

export const SOCIAL_REGISTRATION = 'advaice/registration/SOCIAL_REGISTRATION';
export const SOCIAL_REGISTRATION_SUCCESS = 'advaice/registration/SOCIAL_REGISTRATION_SUCCESS';
export const SOCIAL_REGISTRATION_ERROR = 'advaice/registration/SOCIAL_REGISTRATION_ERROR';

export const RESET_STORE = 'advaice/registration/RESET_STORE';

const initialState = {
  status: INIT,
  id: -1,
  havePassword: false,
  email: '',
  error: '',
  profile: {
    fullName: '',
    company: '',
    website: '',
    position: '',
    timezone: '',
  },
};
export const registrationStore = (state = initialState, action = {}) => {
  switch (action.type) {
    case REGISTRATION:
    {
      return {
        ...state,
        status: LOADING,
      };
    }
    case SOCIAL_REGISTRATION:
    {
      return {
        ...state,
        status: LOADING,
      };
    }
    case REGISTRATION_SUCCESS:
    {
      return {
        ...state,
        status: SUCCESS,
        id: action.payload.id,
        havePassword: action.payload.havePassword,
        email: action.payload.email,
        profile: {
          ...state.profile,
          fullName: action.payload.profile.fullName,
          company: action.payload.profile.company,
          website: action.payload.profile.website,
          position: action.payload.profile.position,
          timezone: action.payload.profile.timezone,
        },
      };
    }
    case REGISTRATION_ERROR:
    {
      return {
        ...state,
        status: ERROR,
        error: action.payload,
      };
    }
    case SOCIAL_REGISTRATION_SUCCESS:
    {
      return {
        ...state,
        status: SUCCESS,
        id: action.payload.id,
        havePassword: action.payload.havePassword,
        email: action.payload.email,
        profile: {
          ...state.profile,
          fullName: action.payload.profile.fullName,
          company: action.payload.profile.company,
          website: action.payload.profile.website,
          position: action.payload.profile.position,
          timezone: action.payload.profile.timezone,
        },
      };
    }
    case SOCIAL_REGISTRATION_ERROR:
    {
      return {
        ...state,
        status: ERROR,
        error: action.payload,
      };
    }
    case ANNUL_ERROR:
    {
      return {
        ...state,
        status: INIT,
        error: '',
      };
    }
    case RESET_STORE:
    {
      return {
        status: INIT,
        id: -1,
        havePassword: false,
        email: '',
        error: '',
        profile: {
          fullName: '',
          company: '',
          website: '',
          position: '',
          timezone: '',
        },
      };
    }
    default:
    {
      return state;
    }
  }
};

export const annulError = () => ({ type: ANNUL_ERROR });
export const registration = data => ({ type: REGISTRATION, payload: data });
export const resetRegistrationStore = () => ({ type: RESET_STORE });

export const socialRegistration = data => ({ type: SOCIAL_REGISTRATION, payload: data });

export const socialRegistrationObservable = (store, requestData) => Observable
  .fromPromise(socialLoginAPI(requestData))
  .map(({ data }) => {
    setUserToken(data.token);
    return { type: REGISTRATION_SUCCESS, payload: data };
  })
  .catch(err => Observable.of({ type: REGISTRATION_ERROR, payload: err }));

export const registrationObservable = (store, requestData) => Observable
  .fromPromise(registrationAPI(requestData))
  .map(({ data }) => {
    setUserToken(data.token);
    return { type: REGISTRATION_SUCCESS, payload: data };
  })
  .catch(err => Observable.of({ type: REGISTRATION_ERROR, payload: err }));

export const registrationEpicLocal = (action$, store) => action$
  .ofType(REGISTRATION)
  .flatMap(action => registrationObservable(store, action.payload));

export const socialRegistrationEpic = (action$, store) => action$
  .ofType(SOCIAL_REGISTRATION)
  .flatMap(action => socialRegistrationObservable(store, action.payload));

export const registrationEpic = combineEpics(registrationEpicLocal, socialRegistrationEpic);



// WEBPACK FOOTER //
// ./src/reducers/registration/duck.js